/**
 * Contains feature flags which are stored in the settings service
 */

export const ORG_STRUCTURE = '/org-structure';

export default {
	ORG_STRUCTURE
};



// WEBPACK FOOTER //
// ./src/main/webapp/media/scripts/webpack/core/featureFlags.js